export interface IFieldProps {
    editable?: boolean;
    key_name: string;
    maxLength?: number;
}

export interface IFieldConfig {
    id: string;
    type: string;
    label: string;
    props: IFieldProps;
    required?: boolean;
    component: TComponentType;
    title?: string;
}

export type TComponentType = 'input';

export const hasAllRequiredValues = (
    uiConfig: IFieldConfig[],
    values: Record<string, any>
) => {
    const requiredFields = uiConfig.filter((field) => field.required);
    const hasAllRequiredValues = requiredFields.every((field) => {
        const key = field.props?.key_name;
        const val = values[key];
        return !!val;
    });
    return hasAllRequiredValues;
};
